import React from 'react';

const ColorsUsage = () => (
  <section>
    <article className="flex-justify-end flex-row last">
      <div className="left">
        <h1 className="h1 page-title">
          Colours have meaning and communicate a tone and emotional response, making them a powerful design tool.
        </h1>
      </div>
      <div className="right copy-content">
        <p>They are responsible for spawning ideas, expressing messages, inspiring interests, and conveying emotions — proving that they should be seen as assets, capable of changing viewers’ perceptions.</p>
        <p>According to the psychology of colours, a colour can portray feelings of excitement, optimism, and creativity as well as sadness, calmness, and harmony. For this reason, colour is a vital component that is seen as part of the brand’s identity and personality and must be chosen carefully. The vibrancy of a colour and the way it complements or contrasts with other elements plays an important role in determining a project’s final outlook.</p>

        <h2 className="h2 page-subtitle">Vibrancy</h2>
        <p>Mainly relates to the emotion a design aims to convey. Bright colours can invoke an emotional response by making users feel more energetic, so these shades are very effective for promotional call outs or calls to action. On the other hand, darker shades encourage relaxation, allowing users to focus on other things.</p>

        <h2 className="h2 page-subtitle">Contrast</h2>
        <p>Used to decrease eye strain and grab users’ attention by clearly dividing elements on a page. It is important to carefully choose background and text colours, as they can change a design’s overall harmony. Highlighting certain areas and using other variations can also help to balance contrast.</p>

        <h2 className="h2 page-subtitle">Complementation</h2>
        <p>Provides balance and leads users to consider a design visually appealing by establishing a happy harmony the eye can dwell on. Therefore, the eye is not restrained to a single area, but rather embraces the totality of the design, creating a balanced environment.</p>
      </div>
    </article>
  </section>
);

export default ColorsUsage;



// WEBPACK FOOTER //
// ./src/containers/foundations/Colors/ColorsUsage.js